import React, { useEffect, useState } from 'react'

import "../styles/documentViewer.scss";
import { AppConfig } from '../config/appConfig';
import moment from 'moment';
import { Alert, Button } from '@mui/material';
import { Buffer } from 'buffer';
import { IWasteCharacterizationDocument } from '../types/wasteCharacterization';


export interface IWasteCharacterizationDocumentViewerProps {
	document: IWasteCharacterizationDocument | undefined,
}

const WasteCharacterizationDocumentViewer: React.FunctionComponent<IWasteCharacterizationDocumentViewerProps> = ({ document }) => {

	//For viewing documents
	const [previewUrl, setPreviewUrl] = useState("");
	const [downloadUrl, setDownloadUrl] = useState("");
	const [fileName, setFileName] = useState("");
	const [title, setTitle] = useState("");

	useEffect(() => {
		loadDocument();
	}, [document])

	const loadDocument = async () => {
		if (document && document.content) {
			setTitle(`${document.name.replace('.pdf', '')}`);
			if (document.name) setFileName(document.name);
			const blob = new Blob([Buffer.from(document.content, "base64")], {
				type: document.contentType 
			});
			const blobUrl = URL.createObjectURL(blob);
			setDownloadUrl(blobUrl);

			if (AppConfig.viewableDocumentTypes.filter((item) => { return item == document.contentType?.toLowerCase() ? true : false; }).length > 0) {
				setPreviewUrl(blobUrl);
			}
			else {
				setPreviewUrl(undefined);
			}
		}
	}
	return (
		<div className="hwi-document-viewer">
			<div className="document-wrapper">
				{previewUrl &&
					<iframe className="document-frame" src={previewUrl}></iframe>
				}
			</div>
		</div>
	)
}

export default WasteCharacterizationDocumentViewer;